/**
 * @name CHAIN
 * @function
 * @description displays the default icon
 * @returns {object}
 */
export const CHAIN = ({ x, y }) => <path className="coe__node__type coe__node__type--chain" transform={ `translate(${ x },${ y }) scale(4,4)` } d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>

/**
 * @name EVENT
 * @constant
 * @function
 * @description  Icon for an event
 * @returns {object}
 */
export const EVENT = ({ x, y }) => <path className="coe__node__type coe__node__type--event" transform={ `translate(${ x },${ y }) scale(2,2)` } d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"></path>

/**
 * @name MEATBALL
 * @constant
 * @function
 * @description Icon for a meatball menu
 * @returns {object}
 */
export const MEATBALL = ({ x, y }) => <path className="coe__node__type coe__node__type--meatball" transform={ `translate(${ x },${ y }) scale(2,2)` } d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>

/**
 * @name ORGANIZATION
 * @constant
 * @function
 * @description Icon for an organization
 * @returns {object}
 */
export const ORGANIZATION = ({ x, y }) => <path className="coe__node__type coe__node__type--organization" transform={ `translate(${ x },${ y }) scale(2,2)` } d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"></path>

/**
 * @name PERSON
 * @constant
 * @function
 * @description Icon for a person
 * @returns {object}
 */
export const PERSON = ({ x, y }) => <path className="coe__node__type coe__node__type--person" transform={ `translate(${ x },${ y }) scale(2,2)` } d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z" />

/**
 * @name PLACE
 * @constant
 * @function
 * @description Icon for a place
 * @returns {object}
 */
export const PLACE = ({ x, y }) => <path className="coe__node__type coe__node__type--place" transform={ `translate(${ x },${ y }) scale(2,2)` } d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path>